(function () {
  'use strict';

  if (window.__thdClosedDropConversionsInstalled) return;
  window.__thdClosedDropConversionsInstalled = true;

  var allowedFormIds = ['Xnz2Nn'];
  var attributionKeys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'utm_id', 'source', 'campaign', 'ad_set', 'adset', 'creative'];
  var maxAttempts = 20;
  var retryDelayMs = 500;
  var pendingStorageKey = 'thd-drop-confirmed-signup:Xnz2Nn';
  var memory = {};
  var pendingPayload = readPending();
  var platformState = {
    'meta-lead': { attempts: 0, timer: null },
    'tiktok-registration': { attempts: 0, timer: null }
  };

  function safeSessionGet(key) {
    try { return window.sessionStorage.getItem(key); } catch (_) { return null; }
  }

  function safeSessionSet(key, value) {
    try { window.sessionStorage.setItem(key, value); } catch (_) {}
  }

  function safeSessionRemove(key) {
    try { window.sessionStorage.removeItem(key); } catch (_) {}
  }

  function storageKey(platform, formId) {
    return 'thd-drop-conversion:' + platform + ':' + formId;
  }

  function hasFired(key) {
    return Boolean(memory[key] || safeSessionGet(key) === '1');
  }

  function markFired(key) {
    memory[key] = true;
    safeSessionSet(key, '1');
  }

  function safeAttribution() {
    var stored = {};
    try { stored = JSON.parse(safeSessionGet('thd-drop-attribution') || '{}'); } catch (_) {}
    if (!stored || typeof stored !== 'object' || Array.isArray(stored)) stored = {};
    var approved = {};
    attributionKeys.forEach(function (key) {
      if (typeof stored[key] === 'string') approved[key] = stored[key];
    });
    try {
      var params = new URLSearchParams(window.location.search || '');
      attributionKeys.forEach(function (key) { if (params.has(key)) approved[key] = params.get(key); });
    } catch (_) {}
    safeSessionSet('thd-drop-attribution', JSON.stringify(approved));
    return approved;
  }

  function properties(formId) {
    var config = window.THDDrop || {};
    var attribution = safeAttribution();
    return {
      content_name: 'THD Drop Signup',
      content_category: 'drop_signup',
      form_id: formId,
      drop: config.drop || '',
      experience: config.experience || '',
      page: window.location.pathname,
      city: config.city || '',
      source: attribution.source || attribution.utm_source || '',
      campaign: attribution.campaign || attribution.utm_campaign || '',
      ad_set: attribution.ad_set || attribution.adset || '',
      creative: attribution.creative || '',
      utm_source: attribution.utm_source || '',
      utm_medium: attribution.utm_medium || '',
      utm_campaign: attribution.utm_campaign || '',
      utm_term: attribution.utm_term || '',
      utm_content: attribution.utm_content || '',
      utm_id: attribution.utm_id || ''
    };
  }

  function readPending() {
    if (safeSessionGet(pendingStorageKey) === null) return null;
    // Pending storage is only a marker; every payload is rebuilt from allowlisted fields.
    return properties(allowedFormIds[0]);
  }

  function clearPendingWhenComplete(formId) {
    if (!hasFired(storageKey('meta-lead', formId)) || !hasFired(storageKey('tiktok-registration', formId))) return false;
    pendingPayload = null;
    safeSessionRemove(pendingStorageKey);
    return true;
  }

  function retainPending(formId) {
    if (clearPendingWhenComplete(formId)) return null;
    if (pendingPayload) return pendingPayload;
    pendingPayload = properties(formId);
    safeSessionSet(pendingStorageKey, '1');
    return pendingPayload;
  }

  function dispatch(platform, payload) {
    if (platform === 'meta-lead') {
      if (typeof window.fbq !== 'function') return false;
      window.fbq('track', 'Lead', payload);
      return true;
    }
    if (!window.ttq || typeof window.ttq.track !== 'function') return false;
    window.ttq.track('CompleteRegistration', payload);
    return true;
  }

  function attemptPlatform(platform, payload) {
    var state = platformState[platform];
    var key = storageKey(platform, payload.form_id);
    state.timer = null;
    if (hasFired(key)) {
      clearPendingWhenComplete(payload.form_id);
      return;
    }
    if (state.attempts >= maxAttempts) return;

    state.attempts += 1;
    var delivered = false;
    try { delivered = dispatch(platform, payload); } catch (_) { delivered = false; }
    if (delivered) {
      markFired(key);
      clearPendingWhenComplete(payload.form_id);
      return;
    }
    if (state.attempts < maxAttempts) {
      state.timer = window.setTimeout(function () { attemptPlatform(platform, payload); }, retryDelayMs);
    }
  }

  function startPlatform(platform, payload) {
    var state = platformState[platform];
    if (hasFired(storageKey(platform, payload.form_id)) || state.timer !== null || state.attempts >= maxAttempts) return;
    attemptPlatform(platform, payload);
  }

  function deliverPending(payload) {
    if (!payload || allowedFormIds.indexOf(payload.form_id) === -1) return;
    if (clearPendingWhenComplete(payload.form_id)) return;
    startPlatform('meta-lead', payload);
    startPlatform('tiktok-registration', payload);
  }

  window.addEventListener('klaviyoForms', function (event) {
    var detail = event && event.detail || {};
    if (detail.type !== 'submit' || allowedFormIds.indexOf(detail.formId) === -1) return;
    deliverPending(retainPending(detail.formId));
  });

  deliverPending(pendingPayload);
})();
